export default "__VITE_ASSET__bf68b60e__"